import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { getRootDomain } from "@util/domain";
import { useAuth } from "@context/auth-context";
import { UserType } from "@models/User";
import { checkIsBusinessUser } from "@util/user.util";
import styles from "./NavBar.module.css";

export type MenuItem = {
    label: string;
    path: string;
    allowedRoles: UserType[];
};

const NavBar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { authState } = useAuth();
    const { user, business } = authState;
    const isBusinessUser = checkIsBusinessUser(user);

    const menuItems: MenuItem[] = [
        { label: "Charities", path: "/charities", allowedRoles: ["root_admin"] },
        { label: "Businesses", path: "/businesses", allowedRoles: ["root_admin"] },
        { label: "Users", path: "/users", allowedRoles: ["root_admin", "business_admin", "demo"] },
        { label: "Anniversaries", path: "/anniversaries", allowedRoles: ["root_admin", "business_admin", "demo"] },
        { label: "Funeral Notices", path: "/upcoming-services", allowedRoles: ["root_admin", "business_admin", "business_user", "demo"] },
        { label: "Memorials", path: "/memorials", allowedRoles: ["root_admin", "business_admin", "business_user", "standard_user", "demo"] },
        { label: "Notifications", path: "/notifications", allowedRoles: ["root_admin"] },
        { label: "Account", path: "/account", allowedRoles: ["root_admin", "business_admin", "business_user", "standard_user", "demo"] },
    ];

    // Filter menu items based on user roles
    const filteredMenuItems = menuItems.filter(
        (item) => user && item.allowedRoles.includes(user.userType),
    );

    const toggleMenu = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    let logoSrc = "/assets/images/fioh-text-logo.png";
    if (isBusinessUser && business?.logo) {
        logoSrc = business.logo;
    }

    return (
        <nav className={styles.navbar}>
            <div className={styles.logo}>
                <a href={getRootDomain()} target="_blank" rel="noopener noreferrer">
                    <img src={logoSrc} alt="Logo" className={styles.logoImage} />
                </a>
            </div>
            <button type="button" className={`${styles.hamburger} ${isOpen ? styles.active : ""}`} onClick={toggleMenu}>
                {/* Hamburger icon */}
                <span className={styles.bar} />
                <span className={styles.bar} />
                <span className={styles.bar} />
            </button>
            <ul className={`${styles.nav} ${isOpen ? styles.navOpen : ""}`}>
                {filteredMenuItems.map((item) => (
                    <li key={item.path} className={styles.navItem}>
                        <NavLink
                            to={item.path}
                            className={({ isActive }) => `${styles.navLink} ${
                                isActive ? styles.active : ""
                            }`}
                            onClick={closeMenu}
                        >
                            {item.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default NavBar;
